module.exports = __webpack_public_path__ + "static/media/admin_landing_splash.a84d7e55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/admin_landing_splash.png
// module id = 2832
// module chunks = 0